{
  "CONTACTS_FILTER": {
    "TITLE": "Фільтр Контактів",
    "SUBTITLE": "Додайте фільтри нижче та натисніть «Відправити», для фільтрації контактів.",
    "EDIT_CUSTOM_SEGMENT": "Редагувати сегмент",
    "CUSTOM_VIEWS_SUBTITLE": "Додайте або видаліть фільтри та оновіть ваш сегмент.",
    "ADD_NEW_FILTER": "Додати фільтр",
    "CLEAR_ALL_FILTERS": "Очистити всі фільтри",
    "FILTER_DELETE_ERROR": "Ви повинні мати хоча б один фільтр для збереження",
    "SUBMIT_BUTTON_LABEL": "Додати",
    "UPDATE_BUTTON_LABEL": "Оновити сегмент",
    "CANCEL_BUTTON_LABEL": "Скасувати",
    "CLEAR_BUTTON_LABEL": "Скинути фільтри",
    "EMPTY_VALUE_ERROR": "Необхідно вказати значення",
    "SEGMENT_LABEL": "Назва сегмента",
    "SEGMENT_QUERY_LABEL": "Запит сегмента",
    "TOOLTIP_LABEL": "Фільтрувати контакти",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "ТА",
      "OR": "АБО"
    },
    "OPERATOR_LABELS": {
      "equal_to": "Дорівнює",
      "not_equal_to": "Не дорівнює",
      "contains": "Містить",
      "does_not_contain": "Не містить",
      "is_present": "Є",
      "is_not_present": "Немає",
      "is_greater_than": "Більше ніж",
      "is_lesser_than": "Менше ніж",
      "days_before": "X днів до"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Необхідно вказати значення"
    },
    "ATTRIBUTES": {
      "NAME": "Ім'я",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Номер телефону",
      "IDENTIFIER": "Ідентифікатор",
      "CITY": "Місто",
      "COUNTRY": "Країна",
      "CUSTOM_ATTRIBUTE_LIST": "Список",
      "CUSTOM_ATTRIBUTE_TEXT": "Текст",
      "CUSTOM_ATTRIBUTE_NUMBER": "Номер",
      "CUSTOM_ATTRIBUTE_LINK": "Лінк",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Прапорець",
      "CREATED_AT": "Створений в",
      "LAST_ACTIVITY": "Остання активність",
      "REFERER_LINK": "Реферальне посилання",
      "BLOCKED": "Заблоковано",
      "LABELS": "Мітки"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Стандартні фільтри",
      "ADDITIONAL_FILTERS": "Додаткові фільтри",
      "CUSTOM_ATTRIBUTES": "Свої атрибути"
    }
  }
}
